import { render, staticRenderFns } from "./CaseTypePreview.vue?vue&type=template&id=eafa2196&scoped=true&"
import script from "./CaseTypePreview.vue?vue&type=script&lang=js&"
export * from "./CaseTypePreview.vue?vue&type=script&lang=js&"
import style0 from "./CaseTypePreview.vue?vue&type=style&index=0&id=eafa2196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafa2196",
  null
  
)

export default component.exports